<div class="highest-overtime-graph">
  <div class="highest-overtime-graph__header">
    <h4 class="highest-overtime-graph__title">{{ 'driverDashboard.graphs.highestOvertime' | transloco }}</h4>
    <svg [ngbTooltip]="'driverDashboard.graphs.highestOvertimeTooltip' | transloco" placement="left"
      xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <circle cx="10" cy="10" r="8" fill="none" stroke="#4D4749" stroke-width="1.5" />
      <line x1="10" y1="14" x2="10" y2="10" stroke="#4D4749" stroke-width="1.5" />
      <circle cx="10" cy="7" r="1" fill="#4D4749" />
    </svg>
  </div>

  <div class="highest-overtime-graph__body">
    @if (isLoading) {
      <div class="highest-overtime-graph__spinner spinner-border"></div>
    } @else if (hasError) {
      <app-graph-error-state></app-graph-error-state>
    } @else if (!hasData) {
      <div class="highest-overtime-graph__no-data">
        <app-empty-state></app-empty-state>
      </div>
    } @else {
      @defer (on timer(100ms)) {
        <div class="highest-overtime-graph__chart">
          <app-horizontal-bar-chart
            [data]="chartData"
            [chartHeight]="180"
            [barPadding]="0.6"
            [xMax]="maxOvertimeValue"
            [xTickInterval]="xTickInterval"
            [showPercentage]="false"
            [showBackgroundBars]="false">
          </app-horizontal-bar-chart>
        </div>
      }
    }
  </div>
</div>